import { Popover } from "react-tiny-popover";
import { JobsStatus, jobStatusToString } from "../../constants/Jobs";
import NfsButton from "../genericComponents/NfsButton/NfsButton";
import "./ExistingJobsPopover.css";
import type Graphic from "@arcgis/core/Graphic";

interface ExistingJobsPopoverProps {
    isOpen: boolean;
    jobs: Graphic[];
    onOpenJob: (job: Graphic) => void;
    onCreateNew: () => void;
    onClose: () => void;
    children: React.JSX.Element;
}

/**
 * Lists the Plan/QA1 jobs that already involve the object, so the user can open one of
 * them instead of creating a duplicate. Creating a new job is always offered.
 */
const ExistingJobsPopover = (props: ExistingJobsPopoverProps) => {
    const hasQA1Jobs = props.jobs.some((job) => job.attributes.status === JobsStatus.QA1);

    return (
        <Popover
            isOpen={props.isOpen}
            onClickOutside={props.onClose}
            positions={["top", "bottom"]}
            boundaryInset={25}
            containerStyle={{ zIndex: "1000" }}
            content={
                <div className="existing-jobs-popover">
                    <div className="existing-jobs-title">Objektet ligger allerede i en jobb</div>
                    <span className="existing-jobs-description">
                        Du kan åpne en eksisterende jobb, eller opprette en ny jobb på objektet.
                    </span>
                    {hasQA1Jobs && (
                        <span className="existing-jobs-warning">
                            Objektet ligger i en jobb til kontroll (QA1). En ny jobb kan gi en duplisert endring.
                        </span>
                    )}
                    <ul className="existing-jobs-list">
                        {props.jobs.map((job) => (
                            <li key={job.attributes.objectid} className="existing-jobs-item">
                                <div className="existing-jobs-info">
                                    <span className="existing-jobs-name">{job.attributes.navn ?? "Uten navn"}</span>
                                    <span className="existing-jobs-status">
                                        {jobStatusToString(job.attributes.status)}
                                    </span>
                                </div>
                                <NfsButton onClick={() => props.onOpenJob(job)} small>
                                    Gå til jobb
                                </NfsButton>
                            </li>
                        ))}
                    </ul>
                    <div className="existing-jobs-create">
                        <NfsButton onClick={props.onCreateNew} empty outlined small>
                            Opprett ny jobb
                        </NfsButton>
                    </div>
                </div>
            }
        >
            {props.children}
        </Popover>
    );
};

export default ExistingJobsPopover;
